import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Governance } from './pages/Governance';
import { Stride } from './pages/Stride';
import { Infrastructure } from './pages/Infrastructure';
import { Technology } from './pages/Technology';
import { Leadership } from './pages/Leadership';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2riknh5rqsbbj">
      <Layout data-id="element-1" data-mp="2mm2nskb9r362">
        <Routes data-id="element-2" data-mp="2mmlu13rk4349">
          <Route path="/" element={<Home data-id="element-4" data-mp="2mnngs5hxqe1t" />} data-id="element-3" data-mp="2mn5bykh7iria" />
          <Route path="/governance" element={<Governance data-id="element-6" data-mp="31ayqe1uk3nza" />} data-id="element-5" data-mp="2mjzp7bw1w1pq" />
          <Route path="/stride" element={<Stride data-id="element-8" data-mp="31cjog1g2xp1w" />} data-id="element-7" data-mp="31c9vq63nh3si" />
          <Route path="/infrastructure" element={<Infrastructure data-id="element-10" data-mp="2wj8g1vvmd07v" />} data-id="element-9" data-mp="2wk9xqj754kyk" />
          <Route path="/technology" element={<Technology data-id="element-12" data-mp="28tw44o8wqe1v" />} data-id="element-11" data-mp="2wi5mthatqlos" />
          <Route path="/leadership" element={<Leadership data-id="element-14" data-mp="28s2xva27hvue" />} data-id="element-13" data-mp="28t4l0cwhy8sh" />
          <Route path="/contact" element={<Contact data-id="element-16" data-mp="23ujkecdc1n3i" />} data-id="element-15" data-mp="23vkzcrxgytqi" />
          <Route path="*" element={<Home data-id="element-18" data-mp="3ijxq4swlw4ky" />} data-id="element-17" data-mp="23v2td3l0915e" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}